import React from 'react';
import {Plugins, Atom, withSystem, Expressions} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const SliderArrow = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const arrowClasses = classes.push(`w-slider-arrow-${data.slider?.dir}`);
    return (
      <div {...generateAttributes(attributes, arrowClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: {
    type: 'Derived',
    defaultValue: 'Slider Arrow',
    getFromElement: (element) => {
      const sliderDir = Expressions.getElementDataAt(
        element,
        [
          {in: 'Record', at: 'slider'},
          {in: 'Record', at: 'dir'},
        ],
        'Text',
        'none'
      );
      return `${
        sliderDir.substr(0, 1).toUpperCase() + sliderDir.substr(1)
      } Arrow`;
    },
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
  },
  render: SliderArrow,
  fields: {
    children: TListOfElement,
    slider: withSystem(
      {private: true},
      TRecord({
        dir: TText,
      })
    ),
  },
});

export default config;
